<style scoped lang="less">
    .line-container{
        width:100%;
    }
    .echarts-line{
        width:100%;
        // height:16rem;
    }
</style>

<template>
    <div class="line-container">
        <div class="echarts-line" :style="{height:lineHeight}" :id="lineId"></div>
    </div>
</template>

<script>
    import echarts from 'echarts';
    /** 
     * 消缺 55AAED
     * 发现 #B489DB
     * 遗留 FD9999
    */
    export default {
        props : ['lineId','xAxis','data','lineHeight','legendPosition','lineColor','tilt','legendData'],
        data() {
            return {
            }
        },
        methods: {
            init() {
                let stationLine = echarts.init(
                    document.getElementById(this.lineId)
                );
                let option = {
                    legend: {
                        x: this.legendPosition,
                        data: this.legendData,
                    },
                    xAxis: {
                        type: 'category',
                        data: this.xAxis,//['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                        axisLabel:{
                            rotate : this.tilt
                        }
                    },
                    yAxis: {
                        type: 'value'
                    },
                    grid: {
                        top: '18%',   // 等价于 y: '16%'
                        left: '1%', 
                        right: '1%',
                        bottom: '1%',
                        containLabel: true
                    },
                    series: [
                        {
                            name: this.legendData[0],
                            type: 'line',
                            data: this.data.thisData//[120, 132, 101, 134, 90, 230, 210]
                        },
                        {
                            name: this.legendData[1],
                            type: 'line',
                            data:  this.data.lastData//[220, 182, 191, 234, 290, 330, 310]
                        },
                        {
                            name: this.legendData[2],
                            type: 'line',
                            data:  this.data.lastTwoMonth//[220, 182, 191, 234, 290, 330, 310]
                        },
                    ],
                    color: this.lineColor
                };
                stationLine.setOption(option, true);
                setTimeout(function (){
                    window.onresize = function () {
                        stationLine.resize();
                    }
                },200)
            },
        },
        mounted() {
            this.init();
        }
    }
</script>